import { createAsyncThunk , createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { config , baseUrl } from "../../utils/baseUrl";
import { userDetailAction } from "./userSlices";

export const createTeamAction = createAsyncThunk('team/create',async(payload,{rejectWithValue,getState,dispatch})=>{
    try {
        const sendData = {
            name : payload.teamName,
            token : localStorage.getItem("token"),
        }

        const {data} = await axios.post(`${baseUrl}/api/team/createTeam`,sendData,config);

        return data;
    } catch (error) {
        if(error?.response){
            return rejectWithValue(error?.response?.data);
        }else{
            throw error;
        }
    }
});

export const jointTeamReqAction = createAsyncThunk('team/joinReq',async(payload,{rejectWithValue,getState,dispatch})=>{
    try {
        const sendData = {
            name : payload.teamName,
            token : localStorage.getItem("token"),
        }

        const {data} = await axios.put(`${baseUrl}/api/team/joinRequest`,sendData,config);

        return data;
    } catch (error) {
        if(error?.response){
            return rejectWithValue(error?.response?.data);
        }else{
            throw error;
        }
    }
});

export const addMemberAction = createAsyncThunk('team/addMem',async(payload,{rejectWithValue,getState,dispatch})=>{
    try {
        const sendData = {
            token : localStorage.getItem("token"),
            memberId : payload.memberId,
        }

        const {data} = await axios.put(`${baseUrl}/api/team/addMember`,sendData,config);

        userDetailAction();

        return data;
    } catch (error) {
        if(error?.response){
            return rejectWithValue(error?.response?.data);
        }else{
            throw error;
        }
    }
});

export const removeMemberAction = createAsyncThunk('team/removeMem',async(payload,{rejectWithValue,getState,dispatch})=>{
    try {
        const sendData = {
            token : localStorage.getItem("token"),
            memberId : payload.memberId,
        }

        const {data} = await axios.put(`${baseUrl}/api/team/removeMember`,sendData,config);

        return data;
    } catch (error) {
        if(error?.response){
            return rejectWithValue(error?.response?.data);
        }else{
            throw error;
        }
    }
});

export const removeFromreq = createAsyncThunk('team/removeReq',async(payload,{rejectWithValue,getState,dispatch})=>{
    try {
        const sendData = {
            token : localStorage.getItem("token"),
            memberId : payload.memberId,
        }

        const {data} = await axios.put(`${baseUrl}/api/team/removeFromReqList`,sendData,config);

        userDetailAction();

        return data;
    } catch (error) {
        if(error?.response){
            return rejectWithValue(error?.response?.data);
        }else{
            throw error;
        }
    }
});

export const leaveTeamAction = createAsyncThunk('team/leave',async(payload,{rejectWithValue,getState,dispatch})=>{
    try {
        const sendData = {
            token : localStorage.getItem("token"),
        }

        const {data} = await axios.put(`${baseUrl}/api/team/leaveteam`,sendData,config);

        return data;
    } catch (error) {
        if(error?.response){
            return rejectWithValue(error?.response?.data);
        }else{
            throw error;
        }
    }
});

export const deleteTeamAction = createAsyncThunk('team/delete',async(payload,{rejectWithValue,getState,dispatch})=>{
    try {
        const sendData = {
            token : localStorage.getItem("token"),
        }

        const {data} = await axios.put(`${baseUrl}/api/team/delete`,sendData,config);

        return data;
    } catch (error) {
        if(error?.response){
            return rejectWithValue(error?.response?.data);
        }else{
            throw error;
        }
    }
});

export const fetchTeamDetails = createAsyncThunk('team/details',async(payload,{rejectWithValue,getState,dispatch})=>{
    try {
        const sendData = {
            token : localStorage.getItem("token"),
        }

        const {data} = await axios.post(`${baseUrl}/api/team/teamDetails`,sendData,config);

        return data;
    } catch (error) {
        if(error?.response){
            return rejectWithValue(error?.response?.data);
        }else{
            throw error;
        }
    }
});

export const teammessageDeleteAction = createAsyncThunk('message/delete',async(payload,{rejectWithValue,getState,dispatch})=>{
    try {
        // Delete message;
    } catch (error) {
        if(error?.response){
            return rejectWithValue(error?.response?.data);
        }else{
            throw error;
        }
    }
});



const teamSlice = createSlice({
    initialState : {
        team : null,
    },
    name : "team",

    extraReducers : (builder)=>{

        //create team
        builder.addCase(createTeamAction.pending,(state,action)=>{
            state.loading = true;
        });
        builder.addCase(createTeamAction.fulfilled,(state,action)=>{
            state.loading = false;
            state.team = action?.payload?.teamDetail;
            state.user = action?.payload?.updatedUser;
            state.appError = null;
            state.serveError = null;
        });
        builder.addCase(createTeamAction.rejected,(state,action)=>{
            state.loading = false;
            state.appError = action?.payload?.message;
            state.serveError = action?.payload?.message;
        });

        //join Team
        builder.addCase(jointTeamReqAction.pending,(state,action)=>{
            state.loading = true;
        });
        builder.addCase(jointTeamReqAction.fulfilled,(state,action)=>{
            state.loading = false;
            state.message = action?.payload?.message;
            state.appError = null;
            state.serveError = null;
        });
        builder.addCase(jointTeamReqAction.rejected,(state,action)=>{
            state.loading = false;
            state.appError = action?.payload?.message;
            state.serveError = action?.payload?.message;
        });

        //add member
        builder.addCase(addMemberAction.pending,(state,action)=>{
            state.loading = true;
        });
        builder.addCase(addMemberAction.fulfilled,(state,action)=>{
            state.loading = false;
            state.user = action?.payload?.leader;
            state.team = action?.payload?.team;
            state.appError = null;
            state.serveError = null;
        });
        builder.addCase(addMemberAction.rejected,(state,action)=>{
            state.loading = false;
            state.appError = action?.payload?.message;
            state.serveError = action?.payload?.message;
        });

        //remove member
        builder.addCase(removeMemberAction.pending,(state,action)=>{
            state.loading = true;
        });
        builder.addCase(removeMemberAction.fulfilled,(state,action)=>{
            state.loading = false;
            state.user = action?.payload?.leader;
            state.team = action?.payload?.team;
            state.appError = null;
            state.serveError = null;
        });
        builder.addCase(removeMemberAction.rejected,(state,action)=>{
            state.loading = false;
            state.appError = action?.payload?.message;
            state.serveError = action?.payload?.message;
        });

        //remove from request queue
        builder.addCase(removeFromreq.pending,(state,action)=>{
            state.loading = true;
        });
        builder.addCase(removeFromreq.fulfilled,(state,action)=>{
            state.loading = false;
            state.user = action?.payload?.leader;
            state.appError = null;
            state.serveError = null;
        });
        builder.addCase(removeFromreq.rejected,(state,action)=>{
            state.loading = false;
            state.appError = action?.payload?.message;
            state.serveError = action?.payload?.message;
        });

        //Leave Team
        builder.addCase(leaveTeamAction.pending,(state,action)=>{
            state.loading = true;
        });
        builder.addCase(leaveTeamAction.fulfilled,(state,action)=>{
            state.loading = false;
            state.team = null;
            state.appError = null;
            state.serveError = null;
        });
        builder.addCase(leaveTeamAction.rejected,(state,action)=>{
            state.loading = false;
            state.appError = action?.payload?.message;
            state.serveError = action?.payload?.message;
        });

        //Delete Team
        builder.addCase(deleteTeamAction.pending,(state,action)=>{
            state.loading = true;
        });
        builder.addCase(deleteTeamAction.fulfilled,(state,action)=>{
            state.loading = false;
            state.team = null;
            state.appError = null;
            state.serveError = null;
        });
        builder.addCase(deleteTeamAction.rejected,(state,action)=>{
            state.loading = false;
            state.appError = action?.payload?.message;
            state.serveError = action?.payload?.message;
        });

        //Team Details
        builder.addCase(fetchTeamDetails.pending,(state,action)=>{
            state.loading = true;
        });
        builder.addCase(fetchTeamDetails.fulfilled,(state,action)=>{
            state.loading = false;
            state.team = action?.payload?.team;
            state.appError = null;
            state.serveError = null;
        });
        builder.addCase(fetchTeamDetails.rejected,(state,action)=>{
            state.loading = false;
            state.appError = action?.payload?.message;
            state.serveError = action?.payload?.message;
        });

        //delete message
        builder.addCase(teammessageDeleteAction.pending,(state,action)=>{
            state.loading = true;
        });
        builder.addCase(teammessageDeleteAction.fulfilled,(state,action)=>{
            state.loading = false;
            state.message = null;
            state.appError = null;
            state.serveError = null;
        });
        builder.addCase(teammessageDeleteAction.rejected,(state,action)=>{
            state.loading = false;
            state.appError = null;
            state.serveError = null;
        });

    }
});

export default teamSlice.reducer;